module.exports = __webpack_public_path__ + "img/smallkinesio.28c6ca13.jpg";